import type { LogisticsRow } from '@contracts';

/**
 * Plan de redistribución "traer de otras tiendas". Responde: qué producto, qué
 * tienda lo pide (y su stock), cuánto necesita, de qué tienda traerlo (con su
 * stock y excedente) y cuánto le pasa.
 */
export function RedistributionTableWidget({ data }: { data: LogisticsRow[] }) {
  const rows = Array.isArray(data) ? data : [];
  if (!rows.length) {
    return <div className="grid h-full place-items-center text-sm text-slate-400">Sin movimientos sugeridos</div>;
  }

  const dot = (s?: string) =>
    s === 'critical' ? 'bg-red-500' : s === 'warn' ? 'bg-amber-400' : 'bg-emerald-500';

  return (
    <div className="h-full overflow-auto pr-1">
      <table className="w-full text-sm">
        <thead className="sticky top-0 bg-white">
          <tr className="text-[10px] font-bold uppercase tracking-wide text-slate-400">
            <th className="py-1 text-left">Producto</th>
            <th className="py-1 text-left">Tienda (pide)</th>
            <th className="py-1 text-right">Stock</th>
            <th className="py-1 text-right">Necesita</th>
            <th className="py-1 text-left">Traer de</th>
            <th className="py-1 text-right">Stock orig.</th>
            <th className="py-1 text-right">Pasa</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r, i) => (
            <tr key={i} className="border-b border-slate-50 last:border-0 hover:bg-slate-50/60">
              <td className="py-1.5">
                <span className="flex items-center gap-1.5">
                  <span className={`h-2 w-2 shrink-0 rounded-full ${dot(r.status)}`} />
                  <span className="truncate text-slate-700">{r.name}</span>
                </span>
                {r.sku && <span className="block pl-3.5 text-[10px] text-slate-400">{r.sku}</span>}
              </td>
              <td className="py-1.5 text-slate-600">{r.pos ?? '—'}</td>
              <td className={`py-1.5 text-right tabular-nums ${(r.stock ?? 0) <= 0 ? 'text-red-600 font-semibold' : 'text-slate-500'}`}>
                {r.stock ?? 0}
              </td>
              <td className="py-1.5 text-right tabular-nums font-semibold text-slate-700">{r.units ?? 0}</td>
              <td className="py-1.5 text-slate-600">
                {r.fromPos || '—'}
                {r.fromSurplus != null && (
                  <span className="ml-1 text-[10px] text-emerald-600">exc. {r.fromSurplus}</span>
                )}
              </td>
              <td className="py-1.5 text-right tabular-nums text-slate-500">{r.fromStock ?? '—'}</td>
              <td className="py-1.5 text-right tabular-nums font-bold text-blue-600">{r.transferQty ?? r.units ?? 0}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
